module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_TALCO_CHEVRON.a7468d1b.png";